import * as React from 'react';

import type { Program } from 'bundles/page-header/components/EnterpriseProgramLogo';
import EnterpriseProgramLogo from 'bundles/page-header/components/EnterpriseProgramLogo';
import ThirdPartyOrganizationLogo from 'bundles/page-header/components/ThirdPartyOrganizationLogo';
import type { ThirdPartyOrganization } from 'bundles/page-header/components/ThirdPartyOrganizationLogo';

type Props = {
  logoHeight?: number;
  logoWidth?: number;
  defaultSize?: number;
  preferRectangle?: boolean;
  program?: Program;
  thirdPartyOrganization?: ThirdPartyOrganization;
  alt?: string;
};

const EnterpriseLogo = ({
  preferRectangle,
  logoHeight,
  logoWidth,
  defaultSize,
  thirdPartyOrganization,
  program,
  alt,
}: Props) => {
  const showProgramLogo = program?.metadata?.rectangularLogo || program?.metadata?.squareLogo;
  const commonProps = { preferRectangle, logoHeight, logoWidth, alt };

  if (showProgramLogo) {
    return <EnterpriseProgramLogo {...commonProps} program={program} />;
  }
  return (
    <ThirdPartyOrganizationLogo
      {...commonProps}
      defaultSize={defaultSize}
      thirdPartyOrganization={thirdPartyOrganization}
    />
  );
};

export default EnterpriseLogo;
